import { render, staticRenderFns } from "./DlgEventHostDelete.vue?vue&type=template&id=50b3a776&scoped=true"
import script from "./DlgEventHostDelete.vue?vue&type=script&lang=ts"
export * from "./DlgEventHostDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3a776",
  null
  
)

export default component.exports